// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: absolute;
  inset: -60px 0 0 0;
  pointer-events: none;
  z-index: 0;
  display: block;
}

.bg-anim {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.fall {
  position: absolute;
  top: -12vh;
  left: 0;
  width: 120px;
  height: 120px;
  transform: translate3d(var(--x, 0), -12vh, 0) scale(var(--scale, 1));
  opacity: 0;
  will-change: transform, opacity;
  image-rendering: auto;
}

.fall.drum {
  background: url("/assets/img/drumstick.png") center/contain no-repeat;
}

.fall.flake {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: radial-gradient(circle at center, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.85) 45%, rgba(255, 255, 255, 0) 100%);
}

@media (max-width: 767px) {
  .fall {
    width: 80px;
    height: 80px;
  }
  .fall.flake {
    width: 6px;
    height: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/campaign/advent-calendar/components/snow-layer/snow-layer.component.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,UAAA;EACA,cAAA;AAFF;;AAKA;EACE,kBAAA;EACA,QAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oEAAA;EACA,UAAA;EACA,+BAAA;EACA,qBAAA;AAFF;;AAKA;EACE,qEAAA;AAFF;;AAKA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,uIAAA;AAFF;;AAKA;EACE;IACE,WAAA;IACA,YAAA;EAFF;EAKA;IACE,UAAA;IACA,WAAA;EAHF;AACF","sourcesContent":["@use '../../../../../../assets/styles/colors' as colors;\n@use '../../../../../../assets/styles/bootstrap-essentials';\n\n:host {\n  position: absolute;\n  inset: -60px 0 0 0;\n  pointer-events: none;\n  z-index: 0;\n  display: block;\n}\n\n.bg-anim {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n}\n\n.fall {\n  position: absolute;\n  top: -12vh;\n  left: 0;\n  width: 120px;\n  height: 120px;\n  transform: translate3d(var(--x, 0), -12vh, 0) scale(var(--scale, 1));\n  opacity: 0;\n  will-change: transform, opacity;\n  image-rendering: auto;\n}\n\n.fall.drum {\n  background: url('/assets/img/drumstick.png') center / contain no-repeat;\n}\n\n.fall.flake {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: radial-gradient(circle at center, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.85) 45%, rgba(255, 255, 255, 0) 100%);\n}\n\n@media (max-width: 767px) {\n  .fall {\n    width: 80px;\n    height: 80px;\n  }\n\n  .fall.flake {\n    width: 6px;\n    height: 6px;\n  }\n}\n\n@include bootstrap-essentials.media-breakpoint-up(lg) {}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
